(function ($) {
    var $slider,
        activeSlider = false;

    this.init = function () {
        this.BlogPromo();
    };

    /****************************************************************
     HOMEPAGE BANNER
    ****************************************************************/
    this.BlogPromo = function () {

        $slider = $(".blogpromo-bottom .row");

        if (window.innerWidth < 992 && !activeSlider) {
            BuildBlogPromoSlider();
        }

        $(window).on("resize", function () {
            // if we re now less than 991, AND we are currently unslicked, THEN we need to rebuild the slider.
            if (window.innerWidth < 992 && !activeSlider) {
                BuildBlogPromoSlider();
            }
        });

        function BuildBlogPromoSlider() {

            activeSlider = true;

            $slider.slick({
                dots: false,
                arrows: true,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous Slide" tabindex="0" role="button"><i class="fa-solid fa-angles-left"></i></button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next Slide" tabindex="0" role="button"><i class="fa-solid fa-angles-right"></i></button>',
                centerMode: false,
                centerPadding: "50px",
                centerMode: true,
                appendArrows: $(".blogpromo-controls"),
                slidesToShow: 1,
                autoplay: false,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 9999,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            arrows: true,
                            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous Slide" tabindex="0" role="button"><i class="fa-solid fa-angles-left"></i></button>',
                            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next Slide" tabindex="0" role="button"><i class="fa-solid fa-angles-right"></i></button>',
                            centerMode: false,
                            centerPadding: "50px",
                            centerMode: true,
                            appendArrows: $(".blogpromo-controls"),
                            slidesToShow: 1,
                            autoplay: false,
                            infinite: true,

                        }
                    }
                ]
            });

            $slider.on("destroy", function () {
                activeSlider = false;
            });

        }
    };

    this.init();

})(jQuery);